import {
  BulkSendPushNotificationRequest,
  BulkSendPushNotificationResponse,
  ListPushNotificationCategoriesResponse,
  PushNotificationCategoryResponse,
  PushNotificationsApi,
  RegisterPushNotificationCategoryRequest,
} from '@Generated/back-office-client/src'
import { BackOfficeDataServiceAPI } from './back-office-data-service'

const listCategories = async (
  customerId: string,
): Promise<ListPushNotificationCategoriesResponse> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(PushNotificationsApi)
  return await api.listPushNotificationCategories({ customerId })
}

const registerCategory = async (
  customerId: string,
  body: RegisterPushNotificationCategoryRequest,
): Promise<PushNotificationCategoryResponse> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(PushNotificationsApi)
  return await api.registerPushNotificationCategory({
    customerId,
    registerPushNotificationCategoryRequest: body,
  })
}

const bulkSend = async (
  customerId: string,
  body: BulkSendPushNotificationRequest,
): Promise<BulkSendPushNotificationResponse> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(PushNotificationsApi)
  return await api.sendBulkPushNotification({
    customerId,
    bulkSendPushNotificationRequest: body,
  })
}

export const PushNotificationServiceAPI = {
  listCategories,
  registerCategory,
  bulkSend,
}
